module.exports = __webpack_public_path__ + "static/img/4.29a394c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/3/sp/4.png
// module id = sJHA
// module chunks = 0